<app-header *ngIf="isBrowser && showHeader"></app-header>
<router-outlet />
<app-footer *ngIf="isBrowser && showFooter && !isMobile"></app-footer>
<app-bottom-nav *ngIf="isBrowser && isMobile && bottomNav"></app-bottom-nav>
<p-toast />
